import { createAction } from '@ngrx/store';

export const swLoadSuccess = createAction('[PWA] Load SW success');
export const swNotAllowed = createAction('[PWA] SW Not Allowed');
